const MISSING_VALUE = '—';

function formatTopCurrency(value: number, forceSign = false) {
    if (!Number.isFinite(value)) return MISSING_VALUE;
    const sign = value > 0 ? (forceSign ? '+' : '') : value < 0 ? '-' : '';
    return `${sign}$${Math.abs(value).toFixed(2)}`;
}

export function formatTradeDetailsPnlDisplay(value: unknown): string {
    if (value == null) return MISSING_VALUE;
    if (typeof value === 'string' && value.trim() === '') return MISSING_VALUE;
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return MISSING_VALUE;
    return formatTopCurrency(numeric, true);
}